export default value => {
  if (value === 'ACTIVE') {
    return 'Active';
  } if (value === 'SUCCEEDED') {
    return 'Succeeded';
  } return 'Active';
};
